import React, { useEffect } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../../styles/ResumeSkeleton.css';

const ResumeSkeleton = () => {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = '';
    };
  }, []);

  return (
    <SkeletonTheme baseColor="#e0e0e0" highlightColor="#f5f5f5">
      <div className="resume-skeleton-container">
        <div className="left-column">
          <div className="section">
            <Skeleton height={30} className="skeleton-small" style={{ marginBottom: '10px' }} />
            <Skeleton height={20} className="skeleton-medium" style={{ marginBottom: '5px' }} />
            <Skeleton height={30} className="skeleton-large" style={{ marginBottom: '10px' }} />
          </div>
          <div className="section">
            <Skeleton height={30} className="skeleton-small" style={{ marginBottom: '10px' }} />
            <Skeleton height={20} className="skeleton-medium" style={{ marginBottom: '5px' }} />
            <Skeleton height={30} className="skeleton-large" style={{ marginBottom: '10px' }} />
          </div>
          <div className="section">
            <Skeleton height={30} className="skeleton-small" style={{ marginBottom: '10px' }} />
            <Skeleton height={20} className="skeleton-medium" style={{ marginBottom: '5px' }} />
            <Skeleton height={30} className="skeleton-large" style={{ marginBottom: '10px' }} />
          </div>
          <div className="section">
            <Skeleton height={30} className="skeleton-small" style={{ marginBottom: '10px' }} />
            <Skeleton height={20} className="skeleton-medium" style={{ marginBottom: '5px' }} />
            <Skeleton height={30} className="skeleton-large" style={{ marginBottom: '10px' }} />
          </div>
        </div>
        <div className="right-column">
          <div className="section">

            <Skeleton count={1} height={20} className="skeleton-large" style={{ marginBottom: '10px' }} />
            <Skeleton height={30} className="skeleton-medium" style={{ marginBottom: '10px' }} />
            <Skeleton height={30} className="skeleton-small" style={{ marginBottom: '10px' }} />
          </div>
          <div className="section">

            <Skeleton count={1} height={20} className="skeleton-large" style={{ marginBottom: '10px' }} />
            <Skeleton height={30} className="skeleton-medium" style={{ marginBottom: '10px' }} />
            <Skeleton height={30} className="skeleton-small" style={{ marginBottom: '10px' }} />
          </div>
          <div className="section">

            <Skeleton count={1} height={20} className="skeleton-large" style={{ marginBottom: '10px' }} />
            <Skeleton height={30} className="skeleton-medium" style={{ marginBottom: '10px' }} />
            <Skeleton height={30} className="skeleton-small" style={{ marginBottom: '10px' }} />
          </div>
          <div className="section">

            <Skeleton count={1} height={20} className="skeleton-large" style={{ marginBottom: '10px' }} />
            <Skeleton height={30} className="skeleton-medium" style={{ marginBottom: '10px' }} />
            <Skeleton height={30} className="skeleton-small" style={{ marginBottom: '10px' }} />
          </div>
        </div>
      </div>
    </SkeletonTheme>
  );
};

export default ResumeSkeleton;
